<template>
    <div class="company-contacts">
        <v-row class="mx-0" v-for="(contact, idx) in contacts" :key="contact.id">
            <v-col cols="12" class="col-sm-6 col-md-4">
                <v-text-field v-model="contacts[idx].contactName" label="Контакт" color="teal" @change="changeContact"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-4">
                <v-text-field v-model="contacts[idx].firstName" label="Имя" color="teal" @change="changeContact"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-4">
                <v-text-field v-model="contacts[idx].lastName" label="Фамилия" color="teal" @change="changeContact"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-4">
                <v-text-field v-model="contacts[idx].email" label="Email" color="teal" @change="changeContact"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-4">
                <v-text-field v-model="contacts[idx].phone" label="Номер телефона" color="teal" @change="changeContact"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-4">
                <v-text-field v-model="contacts[idx].phone2" label="Номер телефона 2" color="teal" @change="changeContact"/>
            </v-col>
<!--            <v-col cols="12" class="col-sm-6 col-md-4">
                <v-text-field v-model="contacts[idx].skypeNickname" label="Skype" color="teal" @change="changeContact"/>
            </v-col>-->
            <v-col cols="12" class="mt-0">
                <v-btn text color="grey" @click="deleteContact(contact.id)">Удалить контакт</v-btn>
            </v-col>
            <v-col cols="12" class="pa-0">
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "CompanyContacts",
        props:['contactsData'],
        data() {
            return {
                contacts: []
            }
        },
        methods: {
            changeContact() {
                this.$emit('change', this.contacts)
            },
            deleteContact(id) {
                this.$emit('delete', {id})
            }
        },
        created() {
            this.contacts = [ ...this.contactsData ];
        },
        watch: {
            contactsData: {
                handler() {
                    this.contacts = Object.create(this.contactsData);
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>
